import { rangePresets, dateFNS } from '@gogame/intl-ts';

const inRange = (range, value) => {
  return dateFNS.isWithinInterval(value, { start: range[0], end: range[1] });
};

const groupData = (data) => {
  return data.reduce((acc, item) => {
    const group = acc.find((g) => g.group === item.group);
    if (group) {
      group.items.push(item);
    } else {
      acc.push({ group: item.group, items: [item] });
    }
    return acc;
  }, []);
};

const getGroupName = (value) => {
  if (inRange(rangePresets.TODAY.value, value)) {
    return rangePresets.TODAY.label;
  }
  if (inRange(rangePresets.LAST_7_DAYS.value, value)) {
    return rangePresets.LAST_7_DAYS.label;
  }
  if (inRange(rangePresets.LAST_30_DAYS.value, value)) {
    return rangePresets.LAST_30_DAYS.label;
  }
  if (inRange(rangePresets.LAST_12_MONTHS.value, value)) {
    return rangePresets.LAST_12_MONTHS.label;
  }
  return 'Older';
};

export const useGroupData = () => {
  return (data) => {
    const groupDataList = [...data].reverse().map((el) => {
      return { ...el, group: getGroupName(el.updatedDate) };
    });
    return groupData(groupDataList);
  };
};
